// Copyright 2022-2026 - Hewlett Packard Enterprise Company
/* eslint-disable import/prefer-default-export */

/*
 * When adding code that consumes an LD flag, add the flag and a default value
 * here as well.  This helps ensure that there is no gap during the initial
 * application loading window prior to receiving the flags from LD where the
 * flag is completely unavailable, causing a run time error.
 */

// Add/remove flags that indigo currently consumes in the following object map
export const ldFlagDefaults = {
  P_20220820_9616_ILO_ONLY_FW_UPDATE_PARAMS_JSON: [],
  P_20230922_589_DSCC_REGION_TO_URL: {
    'AP-NORTHEAST': 'https://jp1.data.cloud.hpe.com',
    'EU-CENTRAL': 'https://eu1.data.cloud.hpe.com',
    'UK-1': 'https://uk1.data.cloud.hpe.com',
    'US-1': 'https://us1.data.cloud.hpe.com',
  },
  P_20230606_569_FWU_PROD_IDS_EXCLUDE_JSON: [
    'P59867-B21',
    'P59868-B21',
    'P59869-B21',
    'P59870-B21',
  ],
  P_20241104_51729_FWU_EXCLUDE_MODEL_GEN_JSON: [{}],
  P_20230104_11587_CID_DISPLAY_BOOL: false,
  P_20250515_CREDENTIAL_BASED_SERVERS_OVERRIDE_SUBSCRIPTION_ENFORCEMENT_JSON:
    [],
  P_20250715_ANALYTICS_USER_EXCEPTIONS_JSON: ['andromedanewuser@gmail.com'],
  P_20250327_971_LIVE_ENDPOINT_MANUAL_CASE_CREATION_BOOL: false,
  P_20260521_136519_HIGHLIGHTED_FEATURE_UI_BOOL: false,
  T_20230418_997_ENDPOINTS_FOR_SERVER_HW_AND_PROFILES_BOOL: false,
  T_20230524_8648_SERVER_PROFILES_UI_BOOL: false,
  T_20230816_7618_ENHANCE_SERVER_HW_INV_REPORT_AGG_BY_DRIVES_BOOL: false,
  T_20230726_10157_RUN_VIEW_FW_COMPLIANCE_REPORT_BOOL: false,
  T_20230726_7582_SERVER_HW_DEVICE_CONTROLLER_REPORT: false,
  P_20231018_20166_NOTIFICATION_BANNER_JSON: {},
  T_20240202_28002_APPLIANCE_URI_ID_DISCREPANCY_FIX: false,
  T_20241014_52081_MAP_VIEW_ENHANCEMENTS_UI_BOOL: false,
  /* Below AHS flag is enabled only for GE customer and disabled for all other customers.
   It should be set to false by default */
  T_20240410_30981_AHS_FILE_UPLOAD_UI_BOOL: false,
  T_20240810_35187_CONFIGURE_OV_SERVER_LOCATION_SERVER_DETAILS_PAGE: false,
  T_20250411_57282_SUSTAINABILITY_UI_TRENDING_BETA_LABEL_BOOL: false,
  T_20241114_49238_UI_SHOW_ACTIVE_NOTIFICATIONS_JSON: {},
  T_20241022_49238_UI_CUSTOM_KNOWN_ISSUE_JSON: {},
  T_20241009_44568_COHESITY_FWU_CASE_BOOL: false,
  T_20240910_52081_MAP_VIEW_CUSTOMAPI_BOOL: true,
  T_20250317_4632_AHS_PWR_TMP_SENS_CSV_JSON_BOOL: false,
  T_20240830_35875_WARNING_TO_PREFLIGHT_BOOL: false,
  T_20241218_50462_ES_COMPLIANCE_ROLLUP_BOOL: false,
  T_20241210_53281_CHATBOT_SUPPORT_BOOL: true,
  T_20250623_73603_COM_APPROVALPOLICY_PHASE2_UI_BOOL: false,
  T_20250312_18961_CONTEXTUAL_HELP_LEARN_MORE_LINKS_BOOL: false,
  T_20250315_18961_CONTEXTUAL_HELP_SHOW_TOPIC_URL_BOOL: false,
  T_20240505_931_INTEGRATE_GLP_HEADER_BOOL: false,
  T_20250205_61638_LIQUID_COOLING_SECTION_HW_INV_UI_BOOL: false,
  T_20260219_122476_INDIGO_PRESELECT_SAME_WORKSPACE_BOOL: false,
  T_20260513_122476_WORKSPACE_DEEP_LINK_BOOL: false,
  T_20260403_122476_APPROVAL_REQUEST_DEEP_LINKS_BOOL: false,
  T_20250526_4857_THIRD_PARTY_SERVER_BETA_UI_BOOL: false,
  T_20250206_60795_SSO_PERMISSIONS_BOOL: true,
  T20250128_4632_AHS_CSV_JSON_BOOL: false,
  T_20250313_971_MANUAL_CASE_CREATION_BOOL: false,
  T_20250409_663_HARDWARE_ATTESTATION_UI_BOOL: false,
  T_20250602_70791_ENABLE_UI_DARK_MODE_BOOL: false,
  T_20260818_70791_USE_BUILT_IN_HELP_LOADER_BOOL: false,
  T_20260701_70791_USE_GLCP_THEME_PREFERENCE_BOOL: false,
  T_20250915_70791_DARK_MODE_HELP_TEST_BOOL: false,
  T_20250527_2252_ILO_SSO_FORM_POST_BOOL: false,
  T_20251004_65559_SESSION_STORAGE_PAGE_RESTORATION: {
    '/activity': false,
    '/appliances': false,
    '/groups': false,
    '/overview': false,
    '/settings': false,
  },
  T_20250605_55452_UPDATE_GROUPS_DTO_BOOL: true,
  T_20250709_89486_SERVER_HARDWARE_REPORT_NEW_UI_BOOL: false,
  T_20250715_73632_CLEAR_UTIL_ALERT: false,
  T_20250729_90010_APPROVAL_V1BETA2_MIGRATION_UI_BOOL: false,
  T_20250812_71009_NOTIFICATION_PREFERENCES_ADMIN: false,
  T_20250902_63753_SG_AUTODISCOVER_ONBOARD_SERVERS_UI_BOOL: false,
  T_20250911_133_SERVER_HW_REPORT_NEW_AGGREGATE_BY_UI_BOOL: false,
  T_20260116_6500_UI_SHOW_REGION_SELECTOR_BOOL: true,
  T_20250106_98741_SUM_MODERNISATION_CFM_UI_BOOL: false,
  T_20260122_88995_LIME_PLAINTEXT_SEARCH_BOOL: false,
  T_20260223_116385_SERVER_FILTER_LINKS_CHATBOT_SUPPORT_BOOL: false,
  T_20260809_148073_CA_FW_UPDATE_LINKS_CHATBOT_SUPPORT_BOOL: false,
  T_20260304_115135_ALL_REGIONS_UI_BOOL: false,
  T_20260330_128443_FW_BUNDLE_UIDOORWAY_API_BOOL: false,
  T_20260303_6826_GROUP_ADD_SERVER_SEARCH_SORT: false,
  T_20251030_660_COM_SETS_PCID_ON_ILO_AUTO_CONNECT_BOOL: true,
  P_20260320_4980_HPE_AHS_SUPPORT_WORKSPACE: false,
  T_20260423_4980_ENABLE_AHS_COPILOT: false,
  T_20260414_128562_STABLE_V1_JOB_API_BOOL: false,
  T_20260420_98974_INVENTORY_COLLECTION_SUSTAINABILITY_INSIGHTS: false,
  T_20260421_101461_NEWFEATURE_ANNOUNCEMENT_UI_BOOL: true,
  T_20260506_49416_iLO_RESET_UI_BOOL: false,
  T_20260429_69543_THEME_VERSION: 8,
  T_20260527_134369_CA_INSIGHTS_SUPPORT_BOOL: false,
  T_20260609_35862_FIRMWARE_ANALYSIS_REPORT_UI_BOOL: false,
  T_20260609_139396_WHATS_NEW_PHASE2_UI_BOOL: false,
  T_20260710_140136_GEN_13_SUPPORT_FWU_UI_BOOL: false,
  T_20260616_94894_DISPLAY_SUPPORT_CASE_UI_BOOL: false,
  T_20260701_70791_USE_NEW_GLCP_PREFERENCES_API_BOOL: false,
  T_20260708_138309_HELIX_APPLIANCE_BOOL: false,
  T_20260713_142685_CONNECTED_HELIX_APPLIANCE_BOOL: false,
  T_20260721_122048_SHA512_SUPPORT_UI_BOOL: false,
  T_20260701_68260_MIGRATE_SI_REPORT_UI_BOOL: false,
  T_20260720_135796_SERVERUTIL_5MINS_ONDEMAND_UI_BOOL: false,
  T_20260629_7243_AUTO_DISCOVER_SUBSCRIPTION_BE_BOOL: false,
  T_20260812_SERVER_FILTER_ID_FALLBACK_BOOL: false,
  T_20260824_5226_FWU_REBOOT_OPTIONS_UI_BOOL: false,
  T_20260819_149994_SERVER_INSIGHTS_REWORK_BOOL: false,
  P_20260825_4980_HPE_AHS_SUPPORT_WORKSPACE_PHASE2: false,
  T_20260709_136074_HIDE_FOLLOW_UPS_IN_UI: {
    alerts: false,
    firmware_baselines: false,
    groups: false,
    metrics: false,
    multi_source: false,
    server_inventory: false,
    servers: false,
  },
};
